export default __webpack_public_path__ + "static/media/superball-b2.0c1fd392.png";